<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center"
      >Losowanie składów - Pozwól by aplikacja zrobiła to za Ciebie!</span
    >
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/lineups.jpg" />

  <div class="or-text-lg or-mb-20-px">Masz dość jednostronnych meczów, gdzie po 20 minutach wynik to już 10:0?</div>
  <div class="or-text-lg or-mb-20-px">
    Z Orlikfy to przeszłość! Nasza aplikacja wylosuje składy za Was, uwzględniając poziom i pozycję graczy, tak by
    drużyny były jak najbardziej wyrównane.
  </div>
  <div class="or-text-lg or-mb-20-px">
    Gra ma być rywalizacją, a nie formalnością – sprawdź nasz system losowania i ciesz się emocjonującą grą do
    ostatniego gwizdka!
  </div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="handleAction()">
    Przejdź do losowania składów!
  </button>

  <button class="button-secondary-style or-h-48-px or-head-md or-w-100-pc" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
